import { AppButton, IconButton } from '@clickguard/design-system'
import PuzzlePiece01 from '@untitled-ui/icons-react/build/esm/PuzzlePiece01'
import Plus from '@untitled-ui/icons-react/build/esm/Plus'
import XClose from '@untitled-ui/icons-react/build/esm/XClose'
import { useUserStore } from 'store'
import { Users } from 'services/user'

const CHROME_EXTENSION_URL =
	'https://chromewebstore.google.com/detail/mlfckffanpidplofdehopinomopjkmem'

export const ExtensionCard = () => {
	const { user, setUser } = useUserStore((s) => ({
		user: s.user,
		setUser: s.setUser
	}))

	const handleDismiss = () => {
		if (user) {
			setUser({
				...user,
				chrome_extension: {
					...user.chrome_extension,
					sidebar_card_dismissed: true
				}
			})
		}
		Users.dismissExtensionCard().catch(() => undefined)
	}

	// w-full, not a fixed 210: the DS footer slot is a 240px box with a 16px
	// gutter each side, so the card's width is the slot's to decide.
	return (
		<div className="app-extension-card flex flex-col gap-3 p-4 bg-[#fafafa] border border-t-checkbox rounded-xl w-full">
			<div className="flex flex-col gap-2">
				<div className="flex items-center gap-2">
					<div className="flex-1 flex items-center gap-2 min-w-0">
						<div className="app-extension-card-icon flex items-center justify-center p-1.5 bg-white border border-t-checkbox rounded-md shrink-0">
							<PuzzlePiece01 className="w-3 h-3 text-[rgb(var(--cg-text-primary))]" />
						</div>
						<span className="text-md font-medium leading-[18px] text-[rgb(var(--cg-text-primary))] whitespace-nowrap">
							Get Extension
						</span>
					</div>
					<IconButton
						icon={<XClose className="w-[14px] h-[14px]" />}
						aria-label="Dismiss extension card"
						size="sm"
						color="secondary"
						onClick={handleDismiss}
						className="!p-[3px] !size-[14px] !rounded-[3px] shrink-0"
					/>
				</div>
				<p className="text-sm leading-4 text-[rgb(var(--cg-text-secondary))]">
					Monitor traffic quality stats directly inside Google Ads.
				</p>
			</div>
			<AppButton
				as="a"
				href={CHROME_EXTENSION_URL}
				target="_blank"
				rel="noopener noreferrer"
				variant="outline"
				size="sm"
				label="Add to Chrome"
				leftIcon={<Plus />}
				fullWidth
				className="!text-[rgb(var(--cg-text-primary))]"
			/>
		</div>
	)
}
